export default __webpack_public_path__ + "static/service-2-c00a291120f2e331a286ac91c88974f0.jpg";